import { render, staticRenderFns } from "./AcceptUserInviteForm.vue?vue&type=template&id=e620ac44"
import script from "./AcceptUserInviteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptUserInviteForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports